import { InternHeadline } from './intern/headline';
import { InternIcon } from './intern/icon';
import { InternLink } from './intern/link';
import { InternOverline } from './intern/overline';

/**
 * Model definition for AdviceBox
 */
export interface AdviceBox {
  __contentType: 'advice-box';
  id: string;
  publication_id?: number;
  publication_date?: Date;
  publication_state?: 'draft' | 'live' | 'archived' | 'unpublished' | 'preview';
  publish_at?: Date | null;
  name?: string;
  text?: string;
  headline?: InternHeadline;
  overline?: InternOverline;
  icon?: InternIcon;
  link: InternLink;
}

export function isAdviceBox(obj: { __contentType?: string }): obj is AdviceBox {
  return obj.__contentType === 'advice-box';
}
